import { AppContextProvider } from "@/contexts";
import { HomePageHeader } from "../../organisms";
import * as S from "./styles";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <AppContextProvider>
      <S.MainLayout>
        <S.HeaderContainer>
          <HomePageHeader />
        </S.HeaderContainer>
        <S.ContentContainer>
          {children}
        </S.ContentContainer>
      </S.MainLayout>
    </AppContextProvider>
  );
};

export default MainLayout; 